import { StoreState } from "../../store";

const selector = (state: StoreState) => state.payment;

export const paymentSelectors = {};
